// ABOUTME: Centralized query key factory for React Query cache management
// ABOUTME: Ensures consistent keys across hooks for fetching and invalidation

export const queryKeys = {
  wardrobe: {
    all: ['wardrobe'] as const,
    item: (id: string) => ['wardrobe', id] as const,
    category: (cat: string) => ['wardrobe', 'category', cat] as const,
  },
  outfits: {
    all: ['outfits'] as const,
    detail: (id: string) => ['outfits', id] as const,
  },
  gameState: {
    all: ['gameState'] as const,
  },
  wearLogs: {
    all: ['wearLogs'] as const,
    date: (date: string) => ['wearLogs', 'date', date] as const,
    item: (itemId: string) => ['wearLogs', 'item', itemId] as const,
  },
  modules: {
    all: ['modules'] as const,
    detail: (moduleId: string) => ['modules', moduleId] as const,
  },
  challenges: {
    all: ['challenges'] as const,
    status: ['challenges', 'status'] as const,
  },
  profile: {
    all: ['profile'] as const,
  },
  contentChallenges: {
    all: ['contentChallenges'] as const,
    detail: (id: string) => ['contentChallenges', id] as const,
    filtered: (filters: Record<string, string>) =>
      ['contentChallenges', filters] as const,
  },
  contentModules: {
    all: ['contentModules'] as const,
    detail: (id: string) => ['contentModules', id] as const,
    filtered: (filters: Record<string, string>) =>
      ['contentModules', filters] as const,
  },
  contentQuizzes: {
    detail: (id: string) => ['contentQuizzes', id] as const,
  },
  contentSkills: {
    all: ['contentSkills'] as const,
  },
  gameConfig: {
    all: ['gameConfig'] as const,
  },
  userSkills: {
    all: ['userSkills'] as const,
  },
  coach: {
    conversations: ['coach', 'conversations'] as const,
    conversation: (id: string) => ['coach', 'conversation', id] as const,
    analysis: ['coach', 'analysis'] as const,
    memories: ['coach', 'memories'] as const,
  },
}
